import { Dialog, DialogContent } from "@/components/ui/dialog";
import CheckoutStep1 from "./CheckoutStep1";
import CheckoutStep2 from "./CheckoutStep2";

/**
 * Checkout dialog orchestrator.
 * Renders Step1 (order type + address) or Step2 (full form) based on current step.
 * All state lives in the parent (PublicMenuPage / useCheckout hook).
 */
export default function CheckoutDialog({
  open, onClose,
  restaurant, tc, fmt, restaurantId,
  isTableOrder, isOpen,
  table,
  cart, cartTotal, categories, onUpdateQuantity, smartPricing,
  step, onStepChange,
  orderType, onOrderTypeChange,
  delivery, onDeliveryChange,
  customer, onCustomerChange,
  coupon, onCouponChange,
  loyalty, onLoyaltyChange,
  payment, onPaymentChange,
  schedule, onScheduleChange,
  getAvailableDates, getTimeSlots,
  suggestions, onAddSuggestion, onRemoveSuggestion, onTrackUpsell,
  submitting, onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xl bg-white max-h-[90vh] overflow-y-auto">

        {step === 1 && !isTableOrder && (
          <CheckoutStep1
            tc={tc} restaurant={restaurant}
            orderType={orderType} onOrderTypeChange={onOrderTypeChange}
            delivery={delivery} onDeliveryChange={onDeliveryChange}
            onClose={onClose} onNext={() => onStepChange(2)} />
        )}

        {step === 2 && (
          <CheckoutStep2
            tc={tc} restaurant={restaurant} restaurantId={restaurantId} fmt={fmt}
            isTableOrder={isTableOrder} isOpen={isOpen} table={table}
            cart={cart} cartTotal={cartTotal} categories={categories} onUpdateQuantity={onUpdateQuantity} smartPricing={smartPricing}
            schedule={schedule} onScheduleChange={onScheduleChange}
            getAvailableDates={getAvailableDates} getTimeSlots={getTimeSlots}
            coupon={coupon} onCouponChange={onCouponChange}
            loyalty={loyalty} onLoyaltyChange={onLoyaltyChange}
            payment={payment} onPaymentChange={onPaymentChange}
            customer={customer} onCustomerChange={onCustomerChange}
            delivery={delivery} onDeliveryChange={onDeliveryChange}
            orderType={orderType}
            suggestions={suggestions} onAddSuggestion={onAddSuggestion}
            onRemoveSuggestion={onRemoveSuggestion} onTrackUpsell={onTrackUpsell}
            submitting={submitting} onSubmit={onSubmit}
            onBack={() => onStepChange(1)} />
        )}

      </DialogContent>
    </Dialog>
  );
}
